import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1">
            <Link to="/" className="flex flex-col items-start gap-2 mb-4 cursor-pointer">
              <div className="bg-white rounded-lg px-3 py-2">
                <img 
                  src="https://static.readdy.ai/image/ecfc40ffeefdf135692cc83520a4b16c/f58e3285c1424e19fa95f9c3703075da.png" 
                  alt="stashly Logo" 
                  className="h-10 w-auto"
                />
              </div>
            </Link>
            <p className="text-gray-400 text-sm">
              Your trusted platform for secure storage solutions. Find the perfect space for your belongings.
            </p>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-bold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <a href="/how-it-works" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  How It Works
                </a>
              </li>
              <li>
                <a href="/pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Pricing
                </a>
              </li>
              <li>
                <a href="/safety" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Safety
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-lg font-bold mb-4">Explore</h3>
            <ul className="space-y-3">
              <li>
                <a href="/browse" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Browse Spaces
                </a>
              </li>
              <li>
                <a href="/become-host" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Become a Host
                </a>
              </li>


            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-bold mb-4">Support</h3>
            <ul className="space-y-3">
              <li>
                <a href="/help-center" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Help Centre
                </a>
              </li>
              <li>
                <a href="/faq" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  FAQs
                </a>
              </li>
              <li>
                <a href="/trust-safety" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Trust & Safety
                </a>
              </li>
              <li>
                <a href="/terms" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2026 Stashly. All rights reserved.
          </p>

        </div>
      </div>
    </footer>
  );
}
